/* global FB, facebookConnectPlugin */

import System from './system';

let platform = null;

class FacebookLogin {
    static setup (appId) {
        platform = System.platform;
        if (platform.web || platform.webApp) {
            System.insertAsyncInHTML(document, 'script', '//connect.facebook.net/en_US/sdk.js', 'facebook-jssdk');
            // This callback will run after the fetch in Facebook API
            window.fbAsyncInit = () => {
                FB.init({
                    appId, // https://developers.facebook.com
                    xfbml: true,
                    version: 'v2.10' // The latest version in 03/10/2017
                });
            };
        }
    }

    // User status can be:
    //      connected - the person is logged into Facebook, and has logged into your app
    //      not_authorized - the person is logged into Facebook, but has not logged into your app
    //      unknown - the person is not logged into Facebook

    static checkStatus () {
        if (platform.web || platform.webApp) {
            return new Promise((resolve, reject) => FB.getLoginStatus(resolve));
        } else { // CORDOVA
            return new Promise((resolve, reject) => facebookConnectPlugin.getLoginStatus(resolve, reject));
        }
    }

    static checkStatusAndLogin () {
        if (platform.web || platform.webApp) {
            return new Promise((resolve, reject) => {
                FB.getLoginStatus((response) => {
                    if (response.status !== 'connected') {
                        FB.login(logged => {
                            if (logged.status === 'connected') {
                                this.getUser(logged.authResponse).then(resolve);
                            } else {
                                reject(logged);
                            }
                        }, {scope: 'email,public_profile', return_scopes: true}); // Open the facebook pop-up
                    } else {
                        this.getUser(response.authResponse).then(resolve);
                    }
                });
            });
        } else { // CORDOVA
            return new Promise((resolve, reject) => {
                facebookConnectPlugin.getLoginStatus((response) => {
                    console.log('FBresponse ' + response.status);
                    if (response.status !== 'connected') {
                        facebookConnectPlugin.login(['email', 'public_profile'],
                            logged => {
                                if (logged.status === 'connected') {
                                    this.getUser(logged.authResponse).then(resolve);
                                } else {
                                    reject(logged);
                                }
                            })
                    } else {
                        this.getUser(response.authResponse).then(resolve);
                    }
                });
            });
        }
    }

    static getUser ({accessToken, userID}) {
        if (platform.web || platform.webApp) {
            return new Promise((resolve, reject) => {
                const config = {access_token: accessToken, fields: 'email, name'};
                FB.api('/' + userID, 'get', config, (user) => {
                    let finalUser = {
                        id: user.id,
                        token: accessToken,
                        name: user.name,
                        email: user.email
                    };
                    resolve(finalUser);
                });
            });
        } else {
            return new Promise((resolve, reject) => {
                facebookConnectPlugin.api('/' + userID + '/?fields=id,email,name', ['email', 'public_profile'], (user) => {
                    let finalUser = {
                        id: user.id,
                        token: accessToken,
                        name: user.name,
                        email: user.email
                    };
                    resolve(finalUser);
                });
            });
        }
    }

    static logout () {
        if (platform.web || platform.webApp) {
            return new Promise((resolve, reject) => FB.logout(resolve));
        } else { // CORDOVA
            return new Promise((resolve, reject) => facebookConnectPlugin.logout(resolve, reject));
        }
    }

    static checkStatusAndLogout () {
        if (platform.web || platform.webApp) {
            return new Promise((resolve, reject) => {
                FB.getLoginStatus((response) => {
                    if (response.status === 'connected') {
                        FB.logout(resolve);
                    } else {
                        resolve(response);
                    }
                });
            });
        } else { // CORDOVA
            return new Promise((resolve, reject) => {
                facebookConnectPlugin.getLoginStatus((response) => {
                    if (response.status === 'connected') {
                        FB.logout(resolve);
                    } else {
                        resolve(response);
                    }
                });
            });
        }
    }
}

export default FacebookLogin;



// WEBPACK FOOTER //
// ./src/utils/facebookLogin.js